import * as React from 'react'

import heart from 'src/assets/images/heart.png'
import 'src/assets/css/main.css';
import 'src/assets/css/reset.css';
import 'src/assets/css/fonts.css';
import 'src/assets/css/hover.css';
import 'src/assets/css/swiper.min.css';
import {IPostSwiperComponentProps} from "./IPostSwiperComponentProps";
import {IPostSwiperComponentState} from "./IPostSwiperComponentState";
import empty from 'src/assets/images/empty.jpg'
import { Link, withRouter } from 'react-router-dom'

export class PostSwiperComponent extends React.Component<IPostSwiperComponentProps, IPostSwiperComponentState> {

    constructor(props: IPostSwiperComponentProps) {
        super(props)

        // Default state
        this.state = {}
    }
    public render() {

        const {favorites , image , title , id} = this.props

        return (
        <div className="_ctn"  onClick={()=> {this.props.history.push('/gif/'+ id)}} style={{marginRight: '15px' }}>

                <div className="_img" >
                    <img src={image} alt="" style={{minHeight:'240px' ,maxHeight:'240px' }} />
                </div>

                <div className="counter">
                    <img src={heart} alt=""/>
                    <span>{favorites}</span>
                </div>

                <div className="description" style={{marginLeft:0}}>
                    <p>{title}</p>
                </div>
            </div>


        );

    }

}

export default (withRouter(PostSwiperComponent))



// WEBPACK FOOTER //
// ./src/components/postSwiperComponent/PostSwiperComponent.tsx